export default class AcessoViewModel {
	constructor () {
        this.UsuarioId = undefined;
        this.GrupoId = undefined;
        this.Claim = undefined;
        this.flag = undefined;
	}
}